import { render, staticRenderFns } from "./WebhookEventGroups.vue?vue&type=template&id=7b45edf9&"
import script from "./WebhookEventGroups.vue?vue&type=script&lang=js&"
export * from "./WebhookEventGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports